import { useState } from 'react'
import GCartSigns from './GCartSigns.jsx'
import GReports from './GReports.jsx'
import GFormats from './GFormats.jsx'
import GMultiFormat from './GMultiFormat.jsx'
import GSeason from './GSeason.jsx'

// Isolated Golf Genius staging container. A feature registry + sub-nav; each
// G- feature is a self-contained, READ-ONLY panel. Future G-* features slot
// into FEATURES beside these.
const FEATURES = [
  { key: 'cartsigns', label: 'G-CartSigns', Comp: GCartSigns },
  { key: 'reports',   label: 'G-Reports',   Comp: GReports },
  { key: 'formats',   label: 'G-Formats',   Comp: GFormats },
  { key: 'multiformat', label: 'G-MultiFormat', Comp: GMultiFormat },
  { key: 'season',    label: 'G-Season',    Comp: GSeason },
]

export default function GGStaging() {
  const [active, setActive] = useState(FEATURES[0].key)
  const Active = (FEATURES.find((f) => f.key === active) || FEATURES[0]).Comp
  return (
    <div className="space-y-4">
      <div className="card">
        <div className="flex flex-wrap items-baseline justify-between gap-2">
          <h3 className="font-bold text-lg">🧪 G-New Features</h3>
          <span className="text-xs pill-amber">staging · read-only · in progress</span>
        </div>
        <p className="text-xs text-gray-500 mt-1">
          Isolated preview area for Golf Genius features. Nothing here writes to scoring, the
          leaderboard, or photos. Approved features graduate into the real flow and drop the “G-”.
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
          {FEATURES.map((f) => {
            const on = active === f.key
            return (
              <button key={f.key} onClick={() => setActive(f.key)}
                className="rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider transition"
                style={on ? { backgroundColor: 'var(--ge-primary)', color: '#fff' } : { backgroundColor: '#F3F4F6', color: '#374151' }}>
                {f.label}
              </button>
            )
          })}
        </div>
      </div>
      <Active />
    </div>
  )
}
